import React, { useState, useEffect } from "react";
import MwSelectorAccount from "../../../components/ui/MwSelectorAccount";
import { MwInputText, MwSelector } from "../../../components/ui";
import MwSelectorCostCenterAccount from "../../../components/ui/MwSelectorCostCenterAccount";
import { useTranslation } from "react-i18next";
import { useAccountSettings } from "../../../contexts/AccountSettingsContext";

const IncomesFormListItem = ({
  index,
  item,
  incomesFormItemsState,
  setIncomesFormItemsState,
  _taxTypeList,
  errors,
  addNewHandler,
  isLinkedInvoiceIncome = false,
  treasuryAccount = null,
  disabledAll = false,
}) => {
  const { getChartAccountLevelLimit, getCostCenterLevelLimit } = useAccountSettings();
  const [t] = useTranslation("global");
  const [localItem, setLocalItem] = useState(item);

  const chartLevelLimit = getChartAccountLevelLimit();
  const costCenterLevelLimit = getCostCenterLevelLimit();

  useEffect(() => {
    setLocalItem(item);
  }, [item]);

  const updateItem = (key, value) => {
    setIncomesFormItemsState((prev) =>
      prev.map((itm, i) => (i === index ? { ...itm, [key]: value } : itm))
    );
  };

  const deleteItemHandler = () => {
    if (incomesFormItemsState.length > 1) {
      setIncomesFormItemsState((prev) => prev.filter((_, i) => i !== index));
    } else {
      setIncomesFormItemsState([
        {
          amount: "",
          to_account_no: "",
          tax_type: "",
          to_cost_account_no: "",
          desc: "",
        },
      ]);
    }
  };

  // ===== FIX: استخرج اسم الضريبة من _taxTypeList بدل ما تعرض القيمة الرقمية =====
  const linkedTaxLabel = (() => {
    if (!localItem?.tax_type) return "0.00";
    // لو tax_type عنده label جاهز (object من الـ match)
    if (localItem.tax_type?.label) return localItem.tax_type.label;
    // لو string أو number، دور عليه في القائمة
    const taxId = String(localItem.tax_type?.id || localItem.tax_type || "").trim();
    const found = _taxTypeList?.find((t) => String(t.id) === taxId);
    return found?.label || localItem?.tax_amount_value || "0.00";
  })();
  // ==============================================================================

  return (
    <div className="flex w-full mx-auto flex-row gap-2 mb-2">
      <div className="min-w-0">
        <MwInputText
          inputType="text"
          label={t("Salaries.BondAmount")}
          value={localItem.amount}
          disabled={isLinkedInvoiceIncome || disabledAll}
          placeholder={t("Bond.amount") + "..."}
          invalid={index === incomesFormItemsState.length - 1 && !!errors?.amount}
          invalidMsg={index === incomesFormItemsState.length - 1 && errors?.amount}
          onChange={(e) => {
            let value = e.target.value;
            if (/^\d*\.?\d{0,2}$/.test(value)) {
              updateItem("amount", value);
            }
          }}
          onBlur={() => {
            if (localItem?.amount) {
              updateItem("amount", parseFloat(localItem?.amount).toFixed(2));
            }
          }}
          classNameInput="border border-[#8D82B6] border-opacity-55 text-[#261759] text-xl text-lg outline-none"
        />
      </div>

      <div className="flex-grow mt-1 min-w-0">
        <MwSelectorAccount
          onChangeCallback={(selectedAccount) => {
            updateItem("to_account_no", selectedAccount?.account_no || "");
          }}
          withLabel={true}
          initialValue={`${item.to_account_no || ""}`}
          placeholder={t("Bond.account") + "..."}
          disabled={disabledAll}
          treasuryAccount={treasuryAccount}
          levelLimit={chartLevelLimit}
        />
      </div>

      <div className="w-48">
        {isLinkedInvoiceIncome || disabledAll ? (
          // ===== FIX: عرض اسم الضريبة مش القيمة الرقمية =====
          <MwInputText
            inputType="text"
            disabled={true}
            label={t("Salaries.Vat")}
            value={linkedTaxLabel}
            classNameInput="border border-[#8D82B6] border-opacity-55 text-[#261759] text-xl text-lg outline-none"
          />
        ) : _taxTypeList && _taxTypeList.length > 0 ? (
          <MwSelector
            label={t("Salaries.Vat")}
            initalValue={t("invoice.selectVat") + "..."}
            dataType={"labelValue"}
            _data={_taxTypeList}
            withAddNew={false}
            withSearch={false}
            invalid={index === incomesFormItemsState.length - 1 && !!errors?.taxType}
            invalidMsg={index === incomesFormItemsState.length - 1 && errors?.taxType}
            selectedItem={localItem.tax_type}
            setSelectedItem={(newValue) => updateItem("tax_type", newValue || "")}
          />
        ) : (
          <div className="text-gray-400 text-sm ms-10 mt-9">
            {t("Vat.loading") || "Loading..."}
          </div>
        )}
      </div>

      <div className="flex-grow min-w-0 mt-1">
        <MwSelectorCostCenterAccount
          placeholder={t("Bond.center_account") + "..."}
          onChangeCallback={(selectedAccount) =>
            updateItem("to_cost_account_no", selectedAccount?.account_no || "")
          }
          withLabel={true}
          disabled={disabledAll}
          initalValue={`${item.to_cost_account_no || ""}`}
          classNameInput="border border-[#8D82B6] border-opacity-55 text-[#261759] font-bold text-lg outline-none"
          levelLimit={costCenterLevelLimit}
        />
      </div>

      {incomesFormItemsState.length > 1 && (
        <div className="flex-grow min-w-0">
          <MwInputText
            label={t("Salaries.bondDescription")}
            value={localItem.desc}
            disabled={isLinkedInvoiceIncome || disabledAll}
            placeholder={t("Salaries.bondDescription")}
            onChange={(e) => updateItem("desc", e.target.value)}
            classNameInput="border border-[#8D82B6] border-opacity-55 text-red-600 text-xl text-lg outline-none"
          />
        </div>
      )}

      <div className="flex items-center gap-2 mt-5">
        {index > 0 && !isLinkedInvoiceIncome && !disabledAll ? (
          <button onClick={deleteItemHandler} className="text-xs">
            <img className="w-4" src="/assets/icons/Trash.png" alt="delete" />
          </button>
        ) : (
          <button disabled className="px-1 py-2 cursor-not-allowed">
            <img className="w-4" src="/assets/icons/dell.png" alt="delete" />
          </button>
        )}

        {index === incomesFormItemsState.length - 1 &&
          !isLinkedInvoiceIncome &&
          !disabledAll && (
          <button onClick={addNewHandler} className="text-xs">
            <img
              className="w-4 hover:bg-[#D9D5E6] transition-[0.7s]"
              src="/assets/icons/addnew.png"
              alt="add"
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default IncomesFormListItem;
